import wretch from 'wretch';

import { IAppConfigModel } from './types';

export async function apiGetAppConfig(): Promise<IAppConfigModel> {
  const response = await wretch('/api/application/config').get().res();

  const userContext = response.headers.get('user-context');

  const json: IAppConfigModel = await response.json();

  return {
    ...json,
    userContext,
  };
}
